module.exports = __webpack_public_path__ + "static/media/unchecked.20bda55e.svg";